import { Saga } from 'redux-saga'
import { all, fork } from 'redux-saga/effects'
import { boardSaga } from './board'
import { keyFiguresSaga } from './keyFigures'
import { guidesSaga } from './guides'
import { emailsConfigurationSaga } from './emailSettings/configuration'
import { emailSignatureSaga } from './emailSettings/signature'
import sendEmailSaga from './sendMessage/email/sagas'
import sendSmsSaga from './sendMessage/sms/sagas'
import { emailRecipientsSaga } from './sendMessage/recipients'
import { inboxSaga } from './communication/inbox'
import { emailsSaga } from './communication/emails'
import { portalUsersSaga } from './communication/portalUsers'
import { portalSummarySaga } from './communication/portalSummary'
import { emailLabelsSaga } from './communication/labels'
import { contactsSaga } from './communication/contacts'
import { smsSaga } from './communication/smsMessages'
import { subleaseSaga } from 'Modules/Boardwork/Tasks/Sublease/shared/store/sublease'
import { newOwnersSaga } from 'Modules/Boardwork/Tasks/shared/store/newOwners'
import { newOwnersDetailsSaga } from 'Modules/Boardwork/Tasks/shared/store/newOwnerDetails'

 
export const createSagaInjector = (runSaga: any, rootSaga: any) => {
  // Create a dictionary to keep track of injected sagas
  const injectedSagas = new Map()

  const isInjected = (key: string) => injectedSagas.has(key)

  const injectSaga = (key: string, saga: Saga) => {
    // We won't run saga if it is already injected
    if (isInjected(key)) return

    // Sagas return task when they executed, which can be used
    // to cancel them
    const task = runSaga(saga)

    // Save the task if we want to cancel it in the future
    injectedSagas.set(key, task)
  }

  // Inject the root saga as it a staticlly loaded file,
  injectSaga('root', rootSaga)

  return injectSaga
}

export const rootSaga = function* root() {
  yield all([
    fork(boardSaga),
    fork(keyFiguresSaga),
    fork(guidesSaga),
    fork(emailsConfigurationSaga),
    fork(emailSignatureSaga),
    fork(sendEmailSaga),
    fork(sendSmsSaga),
    fork(emailRecipientsSaga),
    fork(inboxSaga),
    fork(emailsSaga),
    fork(portalUsersSaga),
    fork(portalSummarySaga),
    fork(emailLabelsSaga),
    fork(contactsSaga),
    fork(smsSaga),
    fork(subleaseSaga),
    fork(newOwnersSaga),
    fork(newOwnersDetailsSaga),
  ])
}
